@if (isLoading()) {
  <lib-loader />
} @else if (isDataReady()) {
  <span>Break down by</span>
  @for (dimension of dimensions(); track dimension.name) {
    <lib-split-button
      [label]="dimension.name"
      (mainClick)="updateDimension(dimension)"
      [items]="dimensionLevelsByDimension() | mapEntry : dimension.name"
      [icon]="SvgSpriteIcon.ArrowDownSLine"
      [class.is-active]="focusDimension()?.name === dimension.name"
    />
  }
}
